import React, { useEffect } from 'react';
import { Check } from 'lucide-react';

export const Toast = ({ message, show, onHide, duration = 2000 }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onHide();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration, onHide]);

  if (!show) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 toast-animated">
      <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-body text-card shadow-lg">
        <Check className="w-4 h-4 text-success" />
        <span className="text-sm font-medium">{message}</span>
      </div>
    </div>
  );
};

export default Toast;
